module.exports = __webpack_public_path__ + "static/media/Banner-halo.55ce11eb.png";